import { $apply, $set, update } from 'qim';
import { get, pickBy } from 'lodash';

import ActionTypes from 'app/login/ActionTypes';
import { createReducer } from 'app/common/utils/ReduxUtils';

const initialState = {
  hasLastSessionTimedOut: false,

  loginPage: {
    isSubmitting: false,
    touchedFields: {},
    submittedFields: {},
    form: {
      email: '',
      password: '',
    },
    result: '',
    shouldTypePassword: false,
    waitForEmailSubmit: false,
  },

  twoFactorAuthPage: {
    isSubmitting: false,
    touchedFields: {},
    submittedFields: {},
    form: {
      code: '',
    },
    result: '',
  },

  secureSessionAuthPage: {
    isSubmitting: false,
    touchedFields: {},
    submittedFields: {},
    result: '',
  },

  forgotPage: {
    isSubmitting: false,
    touchedFields: {},
    submittedFields: {},
    form: {
      email: '',
    },
    result: '',
  },

  resetPage: {
    isSubmitting: false,
    touchedFields: {},
    submittedFields: {},
    form: {
      password1: '',
      password2: '',
    },
    result: {},
  },

  signUpPage: {
    isSubmitting: false,
    touchedFields: {},
    submittedFields: {},
    form: {
      first_name: '',
      last_name: '',
      email: '',
      password1: '',
      updates: false, // don't sign-up users for app updates by default (GDPR requirement)
    },
    result: '',
  },
};

const updateSubmittedFields = (state, { page }) => {
  const touchedFields = pickBy(state[page].touchedFields, Boolean);
  return [page, 'submittedFields', $set(touchedFields)];
};

const handlers = {
  [ActionTypes.UPDATE_LOGIN_FORM](state, { page, name, value }) {
    return update(
      [
        [page, 'touchedFields', name, $set(true)],
        [page, 'form', name, $set(value)],
        [
          page,
          'waitForEmailSubmit',
          $apply(
            previous =>
              previous ||
              (!get(state, ['loginPage', 'form', 'email'], false) &&
                page === 'loginPage' &&
                name === 'password' &&
                Boolean(value))
          ),
        ],
      ],
      state
    );
  },

  [ActionTypes.RESET_LOGIN_FORM](state, { page }) {
    return update([page, $set(initialState[page])], state);
  },

  [ActionTypes.SUBMIT_LOGIN](state, { page }) {
    return update([[page, 'isSubmitting', $set(true)]], state);
  },

  [ActionTypes.SUBMIT_LOGIN_DONE](state, { page, result }) {
    return update(
      [
        updateSubmittedFields(state, { page }),
        [page, ['isSubmitting', $set(false)], ['result', $set(result)]],
      ],
      state
    );
  },

  [ActionTypes.SUBMIT_LOGIN_FAIL](state, { page }) {
    return update(
      [
        updateSubmittedFields(state, { page }),
        [page, ['isSubmitting', $set(false)], ['result', $set('')]],
      ],
      state
    );
  },

  [ActionTypes.SESSION_TIMED_OUT](state) {
    return update(['hasLastSessionTimedOut', $set(true)], state);
  },

  [ActionTypes.RESET_SESSION_TIMED_OUT](state) {
    return update(['hasLastSessionTimedOut', $set(false)], state);
  },

  [ActionTypes.RESET_RESULT](state, { page }) {
    const initialResultValue = initialState[page].result;
    return update([page, 'result', $set(initialResultValue)], state);
  },
};

const reducer = createReducer(handlers, initialState);

export default reducer;
